// extracted by mini-css-extract-plugin
module.exports =  {"reminder":"reminder__J8NCy","active":"active__YRm5-"};